import { gql } from '@apollo/client/core';

export const deliveryLocation = gql`
    fragment deliveryLocation on Load {
        DeliveryLateCity
        DeliveryLateStateCode
        DeliveryApptEarliest
        DeliveryApptLatest
        DeliveryDeadheadInMiles
        DeliveryLocationIANACode
        DeliveryApptStatusConfirmed
    }
`;

export const deliveryLocationNoConfirmation = gql`
    fragment deliveryLocationNoConfirmation on Load {
        DeliveryLateCity
        DeliveryLateStateCode
        DeliveryApptEarliest
        DeliveryApptLatest
        DeliveryDeadheadInMiles
        DeliveryLocationIANACode
    }
`;

export const pickupLocation = gql`
    fragment pickupLocation on Load {
        PickupEarlyCity
        PickupEarlyStateCode
        PickupApptEarliest
        PickupApptLatest
        PickupDeadheadInMiles
        PickupLocationIANACode
        PickupApptStatusConfirmed
    }
`;

export const pickupLocationNoConfirmation = gql`
    fragment pickupLocationNoConfirmation on Load {
        PickupEarlyCity
        PickupEarlyStateCode
        PickupApptEarliest
        PickupApptLatest
        PickupDeadheadInMiles
        PickupLocationIANACode
    }
`;

export const loadRequirements = gql`
 fragment loadRequirements on Load {
    PermitsRequired
    FreezeProtect
    TankerEndorsement
    IsHazmat
    IsTeam
    IsPermit
    IsPartial
    IsTruckLoad
    IsOverSizeLoad
    IsBlind
    TwicNeeded
 }
`;

export const loadRequirementsNoBlindTwic = gql`
 fragment loadRequirementsNoBlindTwic on Load {
    PermitsRequired
    FreezeProtect
    TankerEndorsement
    IsHazmat
    IsTeam
    IsPermit
    IsPartial
    IsTruckLoad
    IsOverSizeLoad
 }
`;

export const equipmentRequirements = gql`
 fragment equipmentRequirements on Load {
    StrapsNeededCantHave
    StrapsNeededRequired
    TarpsRequired
    SealRequired
    RollDoorsCantHave
    RollDoorsRequired
    LiftGateCantHave
    LiftGateRequired
    LoadBarsCantHave
    LoadBarsRequired
    HighCubeCantHave
    HighCubeRequired
    FoodGradeRequired
    FoodGradeCantHave
    PlateTrailerRequired
    PlateTrailerCantHave
 }
`;

export const specialtyFields = gql`
    fragment specialtyFields on Load {
        IsHazmat
        IsTeam
        IsOverSizeLoad
        IsBlind
        TwicNeeded
        DropTrailer
        TankerEndorsement
    }
`;
